import { render } from "./BuildShowcase.vue?vue&type=template&id=74b17f65&scoped=true"
import script from "./BuildShowcase.vue?vue&type=script&lang=js"
export * from "./BuildShowcase.vue?vue&type=script&lang=js"

import "./BuildShowcase.vue?vue&type=style&index=0&id=74b17f65&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b17f65"]])

export default __exports__